import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/** Default cap for multi-line content; individual fields may use a smaller cap. */
export const DEFAULT_TEXTAREA_MAX_LENGTH = 5000;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, maxLength, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
      maxLength={maxLength ?? DEFAULT_TEXTAREA_MAX_LENGTH}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
